import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { isMobileContext } from "../context/isMobileContext";
import { motion } from "framer-motion";

export default function Banner() {
	const { isMobile } = useContext(isMobileContext);
	const { t } = useTranslation();

	return (
		<div className="home-banner">
			<div className="info">
				{!isMobile ? (
					<div className="header">
						<div className="second-container">
							<motion.h2
								initial={{ opacity: 0, translateY: "95%" }}
								whileInView={{ opacity: 1, translateY: 0 }}
								viewport={{ once: true }}
								transition={{ ease: "easeInOut", duration: 0.7, delay: 0.2 }}
								className="second"
							>
								{t("banner.headLine1")}
							</motion.h2>
						</div>
						<div className="main-title-container">
							<motion.h1
								initial={{ opacity: 0, translateY: "95%" }}
								whileInView={{ opacity: 1, translateY: 0 }}
								viewport={{ once: true }}
								transition={{ ease: "easeInOut", duration: 0.7, delay: 0.7 }}
								className="main-title"
							>
								{t("banner.headLine2-1")}
							</motion.h1>
						</div>
						{/* <div className="main-title-container">
							<motion.h1
								initial={{ opacity: 0, translateY: "95%" }}
								whileInView={{ opacity: 1, translateY: 0 }}
								viewport={{ once: true }}
								transition={{ ease: "easeInOut", duration: 0.7, delay: 1 }}
								className="main-title"
							>
								{t("banner.headLine2-2")}
							</motion.h1>
						</div> */}
						<div className="year-container">
							<motion.h1
								initial={{ opacity: 0, translateY: "95%" }}
								whileInView={{ opacity: 1, translateY: 0 }}
								viewport={{ once: true }}
								transition={{ ease: "easeInOut", duration: 0.7, delay: 1.25 }}
								className="year"
							>
								{t("banner.headLine3")}
							</motion.h1>
						</div>
						<div className="desc">
							<motion.p
							initial={{ opacity: 0 }}
							whileInView={{ opacity: 1 }}
							viewport={{ once: true }}
							transition={{ ease: "easeInOut", duration: 0.7, delay: 1.5 }}
							>
								{t('banner.description')}
							</motion.p>
						</div>
					</div>
				) : (
					<div className="header">
						<div className="second-container">
							<motion.h2
								initial={{ opacity: 0, translateY: "95%" }}
								whileInView={{ opacity: 1, translateY: 0 }}
								viewport={{ once: true }}
								transition={{ ease: "easeInOut", duration: 0.7, delay: 0.2 }}
								className="second"
							>
								{t("banner.headLine1")}
							</motion.h2>
						</div>
						<div className="main-title-container">
							<motion.h1
								initial={{ opacity: 0, translateY: "95%" }}
								whileInView={{ opacity: 1, translateY: 0 }}
								viewport={{ once: true }}
								transition={{ ease: "easeInOut", duration: 0.7, delay: 0.7 }}
								className="main-title"
							>
								{t("banner.headLine2-1")}
							</motion.h1>
						</div>
						{/* <div className="main-title-container">
							<motion.h1
								initial={{ opacity: 0, translateY: "95%" }}
								whileInView={{ opacity: 1, translateY: 0 }}
								viewport={{ once: true }}
								transition={{ ease: "easeInOut", duration: 0.7, delay: 1 }}
								className="main-title"
							>
								{t("banner.headLine2-2")}
							</motion.h1>
						</div> */}
						<div className="year-container">
							<motion.h1
								initial={{ opacity: 0, translateY: "95%" }}
								whileInView={{ opacity: 1, translateY: 0 }}
								viewport={{ once: true }}
								transition={{ ease: "easeInOut", duration: 0.7, delay: 1.25 }}
								className="year"
							>
								{t("banner.headLine3")}
							</motion.h1>
						</div>
					</div>
				)}
				{/* {!isMobile && (
					<motion.div
						initial={{ opacity: 0 }}
						animate={{ opacity: 1 }}
						viewport={{ once: true }}
						transition={{ delay: 2, duration: 1 }}
						className="desc"
					>
						{t("banner.description")}
					</motion.div>
				)} */}
			</div>
			<motion.div className="image-container"
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				viewport={{ once: true }}
				transition={{ delay: 0.5, duration: 2 }}
			>
				<img
					// src={process.env.PUBLIC_URL + `/imgs/home-page/banner-new-desktop.png`}
					src={process.env.PUBLIC_URL + `/imgs/home-page/new-home-banner2.png`}
					alt="home-banner-img"
				/>
			</motion.div>
			<motion.div className="backlayer-1"
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				viewport={{ once: true }}
				transition={{ delay: 0, duration: 1 }}
			>
				<img src={process.env.PUBLIC_URL + "/imgs/home-page/banner-back-layer1.svg"} alt="backlayer-1" />
			</motion.div>
			{/* <div className="backlayer-2">
            <img  src="/imgs/home-page/banner-back-layer2.svg" alt="backlayer-2" />
        </div> */}
		</div>
	);
}
